import { createDomain } from 'effector-root';

const domain = createDomain('Customer Order Breakdown (Page)');

export const onPageStarted = domain.event();